<template>
  <div class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',

  data() {
    return {}
  },

  methods: {
    
  }
}
</script>


<style lang="scss" scoped>
  .loading p{
    padding-top: 150px;
    padding-bottom:30px;
    text-align: center;
    font-size: 28px;
  }
  #colorfulPulse {
    width: 100%;
    text-align: center;
    height: 50px;
    margin:0 auto;
  }
  #colorfulPulse span {
    display: inline-block;
    width: 10px;
    height: 40px;
    animation-name: scale;
    -webkit-animation-name: scale;
    -moz-animation-name: scale;
    -ms-animation-name: scale;
    -o-animation-name: scale;
    animation-duration: 1.2s;
    -webkit-animation-duration: 1.2s;
    -moz-animation-duration: 1.2s;
    -ms-animation-duration: 1.2s;
    -o-animation-duration: 1.2s;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    -ms-animation-iteration-count: infinite;
    -o-animation-iteration-count: infinite;
    /* animation: name duration timing-function delay iteration-count direction */
    /* 属性：动画名称 完成动画花费的时间 动画速度曲线  延迟时间 播放次数 反向播放动画*/
    /* 
    timing-function：linear:匀速，ease:慢快慢，ease-in：慢开始，ease-out：慢结束，ease-in-out:慢开始和结束
   iteration-count：数字/infinite（无数次）
    
    */
  }
  span.item-1 {
    background: #d70a30;
  }
  span.item-2 {
    background: #d70a30;
  }
  span.item-3 {
    background: #d70a30;
  }
  span.item-4 {
    background: #d70a30;
  }
  span.item-5 {
    background: #d70a30;
  }
  span.item-6 {
    background: #d70a30;
  }
  span.item-7 {
    background: #d70a30;
  }
  
  .item-1 {
    animation-delay: -1s;
    -webkit-animation-delay: -1s;
    -moz-animation-delay: -1s;
    -ms-animation-delay: -1s;
    -o-animation-delay: -1s;
  }
  
  .item-2 {
    animation-delay: -0.9s;
    -webkit-animation-delay: -0.9s;
    -moz-animation-delay: -0.9s;
    -ms-animation-delay: -0.9s;
    -o-animation-delay: -0.9s;
  }
  
  .item-3 {
    animation-delay: -0.8s;
    -webkit-animation-delay: -0.8s;
    -moz-animation-delay: -0.8s;
    -ms-animation-delay: -0.8s;
    -o-animation-delay: -0.8s;
  }
  
  .item-4 {
    animation-delay: -0.7s;
    -webkit-animation-delay: -0.7s;
    -moz-animation-delay: -0.7s;
    -ms-animation-delay: -0.7s;
    -o-animation-delay: -0.7s;
  }
  
  .item-5 {
    animation-delay: -0.6s;
    -webkit-animation-delay: -0.6s;
    -moz-animation-delay: -0.6s;
    -ms-animation-delay: -0.6s;
    -o-animation-delay: -0.6s;
  }
  
  .item-6 {
    animation-delay: -0.5s;
    -webkit-animation-delay: -0.5s;
    -moz-animation-delay: -0.5s;
    -ms-animation-delay: -0.5s;
    -o-animation-delay: -0.5s;
  }
  
  .item-7 {
    animation-delay: -0.4s;
    -webkit-animation-delay: -0.4s;
    -moz-animation-delay: -0.4s;
    -ms-animation-delay: -0.4s;
    -o-animation-delay: -0.4s;
  }
  
  @-webkit-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }
  
    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @-moz-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }
  
    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @-ms-keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }
  
    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
  @keyframes scale {
    0%, 40%, 100% {
      -moz-transform: scaleY(0.2);
      -ms-transform: scaleY(0.2);
      -o-transform: scaleY(0.2);
      -webkit-transform: scaleY(0.2);
      transform: scaleY(0.2);
    }
  
    20%, 60% {
      -moz-transform: scaleY(1);
      -ms-transform: scaleY(1);
      -o-transform: scaleY(1);
      -webkit-transform: scaleY(1);
      transform: scaleY(1);
    }
  }
</style>